var productswiper;
var slideoverride=-1;
var origsliderhtml='';
var lastslide=0;
var numslides=0;
var allowfortitle=100;
var swiperoptions = { initialSlide: lastslide, direction: 'horizontal', loop: true, slidesPerView: 'auto', loopedSlides: 20, loopAdditionalSlides: 20, watchSlidesVisibility: false, preloadImages: false, updateOnImagesReady: false, observer: true, observeParents: true, centeredSlides: true, setWrapperSize: false,        roundLengths: true };







/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) 
{
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  
   
  var updatedImageSrc= newImageSrc.replace('_grande', '_2048x2048');
  if (productswiper)
  {
      var slideindex=parseInt($('.swiper-wrapper .swiper-slide img[src="'+updatedImageSrc+'"]').first().parent().data('swiper-slide-index'));
      var activeindex=parseInt($('.swiper-wrapper .swiper-slide-active').first().data('swiper-slide-index'));

      
      if (slideindex!=activeindex)
      {
          slideoverride=slideindex;

          if ( activeindex > slideoverride )
          {
              productswiper.slidePrev(true,250); 
          }
          else if ( activeindex < slideoverride )
          {
              productswiper.slideNext(true,250); 
          }

          $('#productform').velocity('scroll',{duration: 1000,offset:-80});

          
      }
      
  }
  
  
};






jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
  /*==========================*/
  
  var supportsSVG = function() {
    return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
  }  
  if (!supportsSVG()) {
    $('img[src*=".svg"]').remove();
  }
  
  /* Prepare to have floated images fill the width of the design on blog pages on small devices. */
  /*==========================*/ 
    
  var images = $('.article img').load(function() {
    var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
    var width = $(this).width();
    $(this).attr('src', src).attr('width', width).removeAttr('height');
  });
  
  
  
});


jQuery(function($) 
{

      $('body').addClass('ready');

      $( '#home-swiper' ).height($(window).height() + 0);

      $('#searchicon').click(function (){ $(this).closest("form").submit(); });

      $('.currencyoption').click(function() {
          $("a[data-currency='"+Currency.currentCurrency+"']").parent('li').removeClass('active');

          var newCurrency = $(this).data('currency');
          Currency.convertAll(Currency.currentCurrency, newCurrency);
          $('.selected-currency').text(Currency.currentCurrency,'span.money','money_format');

          $("a[data-currency='"+newCurrency+"']").parent('li').addClass('active');

          hideallmainnmenus();
      });

      $("a[data-currency='"+Currency.currentCurrency+"']").parent('li').addClass('active');


      // still need for pages with no images

      setTimeout(function(){ $(window).scroll(); }, 250);


      


      $( 'a.toplink' ).click(function(e){
        e.preventDefault();
        $('html,body').animate({ scrollTop: 0 }, 'slow');
      });

      $( '.scrollnag' ).click(function(e){
        e.preventDefault();
        $('html,body').animate({ scrollTop: $(window).height()-$('#theheader').height() }, 'slow');
      });
      



      
      $( '.rolleffect' ).each(function()
      {
        var origspan=$(this).find('span').not(".roller");
        var rolledspan=$(this).find('span.roller');
        var origi=origspan.find('i');
        var rolledi=rolledspan.find('i');

        var offx=(origi.width()-rolledi.width())/2;
        rolledi.css('margin-left',offx+'px');

      });


         


      var headerheight = $('#theheader').innerHeight();
      var collectionmenuheight = $('#collectionmenu').innerHeight();
      
      if ( !$('body').hasClass('hasheaderimage') )
      {
          if ( $('body').hasClass('template-collection') ) // on collection page without header image
          {
              $('.altheader').css('margin-top',(headerheight)+'px');
          }
          else
          {
              $('.altheader').css('margin-top',(0)+'px');
          }
          
      }

      $( '#collectionmenu' ).css('top',headerheight+'px');
      $( '#collectionmenu' ).fixedsticky();
      $( '#theheader' ).fixedsticky();
      
      function removeShopifyAdminBarHeights() 
      {
          $('#home-swiper').css('top', '');
      }


      setInterval(removeShopifyAdminBarHeights, 500);
      


      var swiper = new Swiper('.home-swiper.swiper-container', {
        pagination: '.home-swiper .swiper-pagination',
        paginationClickable: true
      });


      $( '.swiper-flickthrough' ).each(function()
      {
          var flickthroughswiper = new Swiper(this, {
            centeredSlides: true,
            autoplay: 2500,
            loop: true,
            noSwiping: true,
            onlyExternal: true,
            updateOnImagesReady: false,
            preloadImages: true,
            roundLengths: true,
            observer: true, 
            observeParents: true,
            onTransitionStart: function(swiper)
            {
              //console.log('flickstarted');

            }
          });

          flickthroughswiper.stopAutoplay(); 

          
      });


      



      if ($('#swiperholder .swiper-container').length>0)
      {

        allowfortitle=$('#keyproductinfo').outerHeight()+$('#theheader').innerHeight();

        console.log('allowfortitle'+allowfortitle);

        var winh=$(window).height()-allowfortitle;
        if (winh<500)
        {
          
          winh=$(window).height();
        }

        $('#swiperholder').css('height',winh+'px');
        if ($('body').hasClass('maximised'))
        {
            $('#swiperholder').css('height',($(window).height()-0)+'px');
        }

        numslides=$('#swiperholder .swiper-container').first().find('.swiper-slide').length;
        console.log('numslides: '+numslides);
        origsliderhtml=$('#swiperholder .swiper-container').html();
        

        function clickedSlide()
        {
              
              console.log('clickedSlide');
              var needreboot=false;

              if ($('body').hasClass('maximised'))
              {
                  $('body').removeClass('maximised');
                  needreboot=true;
                 
              }
              else if ( $(this).hasClass( 'swiper-slide-active' ) )
              {
                  $('body').addClass('maximised');
                  needreboot=true;

                  $('html,body').scrollTop(0);
              }

              if (needreboot)
              {
                  lastslide=parseInt($('.swiper-wrapper .swiper-slide-active').first().data('swiper-slide-index'));
                  productswiper.destroy(true,true);
                  allowfortitle=$('#keyproductinfo').outerHeight()+$('#theheader').innerHeight();

                  var winh=$(window).height()-allowfortitle;
                  if (winh<500)
                  {
                    winh=$(window).height();
                  }

                  $('#swiperholder').css('height',winh+'px');
                  $('#product').css('margin-top',(0)+'px');

                  if ($('body').hasClass('maximised'))
                  {
                    $('#swiperholder').css('height',($(window).height()-0)+'px');
                    $('#product').css('margin-top',-(headerheight)+'px');
                  }
                  $('#swiperholder .swiper-container').html(origsliderhtml);
                  swiperInit();
                  
                  $('#swiperholder .swiper-container').css('opacity','0');
                  setTimeout(function(){ $(window).resize(); }, 1);
                
              }

              

        }


        function swiperInit()
        {
            swiperoptions.initialSlide = lastslide;
            if ( numslides >1 )
            {
              
                swiperoptions.nextButton = '.swiper-button-next';
                swiperoptions.prevButton = '.swiper-button-prev';
            }
            productswiper = new Swiper ('#swiperholder .swiper-container', swiperoptions );
             
            $('#swiperholder .swiper-slide').click(clickedSlide);



            productswiper.on('onTransitionEnd',function()
            {
                var activeindex=parseInt($('.swiper-wrapper .swiper-slide-active').first().data('swiper-slide-index'));
                                         
                if (activeindex != slideoverride && slideoverride!=-1)
                {
                  if ( activeindex > slideoverride )
                  {
                     productswiper.slidePrev(true,250); 
                  }
                  else if ( activeindex < slideoverride )
                  {
                    productswiper.slideNext(true,250); 
                  }


                }
                else
                {
                  slideoverride=-1;
                }

            });

            productswiper.on('slideChangeStart', function () 
            {
                //console.log('slideChangeStart');
                
            });

            $('#swiperholder').addClass('isloaded');

        }

       
      
      }

      $( window ).resize(function() 
      {
          console.log('resize');
          $( '#home-swiper' ).height($(window).height() + 0);

          if (productswiper)
          {
              allowfortitle=$('#keyproductinfo').outerHeight()+$('#theheader').innerHeight();
              console.log('allowfortitle'+allowfortitle);

              var winh=$(window).height()-allowfortitle;
              if (winh<500)
              {
                winh=$(window).height();
              }

              $('#swiperholder').css('height',winh+'px');
              if ($('body').hasClass('maximised'))
              {
                  $('#swiperholder').css('height',($(window).height()-0)+'px');
              }
              productswiper.updateContainerSize();
              productswiper.updateSlidesSize();

              $('#swiperholder .swiper-container').css('opacity','1');
          }


          $( 'img.slidebackground' ).each(function()
          {
              resizeSwiperImage(this,false);
          });

          $( 'img.fitcontainer' ).each(function()
          {
              resizeSwiperImage(this,true);
          });



      });

      
    
      

      $('.has-dropdown>a').click(function(e){

        e.preventDefault();

        if ( !$(this).hasClass('active') )
        {
            $(this).addClass('active');
            $(this).parent().find('.sub-nav').velocity("slideDown", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
            $(this).find('i').velocity({rotateZ: "180deg"}, { duration: 500 });
        }
        else
        {
            $(this).removeClass('active');
            $(this).parent().find('.sub-nav').velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
            $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
        }

      });

      
      var stagger=1;
      $('#main').imagesLoaded().progress( function( instance, image ) 
      {

          var result = image.isLoaded ? 'loaded' : 'broken';
        
          if ($(image.img).hasClass('hideuntilloaded'))
          {
              
              setTimeout(function(){ $(image.img).addClass('isloaded'); }, stagger*250);
              setTimeout(function(){ $(image.img).parents('.sweetcontainer').addClass('isloaded'); }, stagger*250);
              
              stagger++;

              $(window).scroll();
          }

          if ($(image.img).hasClass('fitcontainer'))
          {
                   
            var iw = $(image.img).width();
            var ih = $(image.img).height();

            $(image.img).data('iw',''+iw);
            $(image.img).data('ih',''+ih);

            

            resizeSwiperImage(image.img,true);
            

          }


      });

      $('#main').imagesLoaded().always( function( instance, image ) 
      {
          //console.log('all images loaded');
          if ($('#swiperholder .swiper-container').length>0)
          {
              swiperInit();
              //to force centering on ie
              $('#swiperholder .swiper-container').css('opacity','0');
              setTimeout(function(){ $(window).resize(); }, 1);
          }
      });


      $('#home-swiper').imagesLoaded().always( function( instance, image ) 
      {
          $('#home-swiper').addClass('swiper-loaded');
      });

      $('#home-swiper').imagesLoaded().progress( function( instance, image ) 
      {

          var result = image.isLoaded ? 'loaded' : 'broken';
          
          if ($(image.img).hasClass('slidebackground'))
          {
            $(image.img).addClass('isloaded'); 
            $(image.img).parent().addClass('isloaded'); 

            var iw = $(image.img).width();
            var ih = $(image.img).height();

            $(image.img).data('iw',''+iw);
            $(image.img).data('ih',''+ih);

            resizeSwiperImage(image.img,false);

            
            
          }

      });



      function resizeSwiperImage(img,useparent)
      {
          

          var container=window;

          if (useparent)
          {
            container=$(img).parents('.sweetcontainer');
          }
         

          var iw = $(img).data('iw');
          var ih = $(img).data('ih');
          var rat=ih/iw;

          var windoww=$(container).outerWidth();
          var windowh=$(container).outerHeight();
          var neww, newh;

          if (iw>ih)
          {
            //landscape
            neww=windoww;
            newh=neww*rat;

            if (newh<windowh)
            {
                newh=windowh;
                neww=newh/rat;
            }

          }
          else
          {
            //portrait
            newh=windowh;
            neww=newh/rat;

            if (neww<windoww)
            {
                neww=windoww;
                newh=neww*rat;
            }

          }

          var offx=(windoww-neww)/2;
          var offy=(windowh-newh)/2;

          offx=Math.floor(offx);
          offy=Math.floor(offy);

          neww=Math.ceil(neww)+1;
          newh=Math.ceil(newh)+1;

          $(img).css('width',(neww)+'px');
          $(img).css('height',(newh)+'px');
          $(img).css('left',(offx)+'px');
          $(img).css('top',(offy)+'px');
      }

      

      var moveam=10;

      

      

      
      
      $( ".hasslides" ).mouseenter(function() 
      {
          $( this ).addClass('flicking');

          var rolledswiper = $( this ).find('.swiper-flickthrough')[0].swiper;
          rolledswiper.slideTo(2, 500, false);
          rolledswiper.startAutoplay();

          
             
      });

      $( ".hasslides" ).mouseleave(function() 
      {
          var rolledswiper = $( this ).find('.swiper-flickthrough')[0].swiper; 
          rolledswiper.slideTo(1, 500, false);
          rolledswiper.stopAutoplay();  
      });
      

      $( ".zoomer" ).mouseenter(function() 
      {
          var img=$( this ).find('img').not('.nozoom');
          
          if ( (!img.hasClass('hideuntilloaded') || img.hasClass('isloaded')) && !img.hasClass('zooming') )
          {
            img.addClass('zooming')
          }

          
          var caption=$( this ).find('.coll-caption');
          var captionwidth=caption.outerWidth();
          var captionheight=caption.outerHeight();
          var finalarrowwidth=caption.width();

          
          
      });

      $( ".zoomer" ).mouseleave(function() 
      {
          
          var thisref=$(this);
          var img=$( this ).find('img').not('.nozoom');
         
          if (img.hasClass('zooming'))
          {
            img.removeClass('zooming'); 
          }

          
      });


      $(window).scroll(function() 
      { 
                 
          //only need repaint class on webkit - if has native sticky is a good test for this (for now)
          if ( FixedSticky.tests.sticky )
          {
              $( '#main' ).addClass('repaint');
          }

          var stagger=1;
          $( '.offscreen' ).each(function()
          {
            
            if ( $(this).visible( true ) )
            {
                
                var thisref=this;
                setTimeout(function(){ $(thisref).addClass('onscreen'); $(thisref).removeClass('offscreen'); }, stagger*250);
                stagger++;
            }
          });


          if ( $('body').hasClass('template-product') ) // on product page
          {
              
              //un-maximize if buy button visible
              if ( $('#add').visible( true ) )
              {
                  clickedSlide();
              }
            
              
          }



      });



      $('#sweetvariantsmenu .menutoggle').click(function()
      {
          var clickedmenu=this;

          $( '#sweetvariantsmenu .menutoggle' ).each(function( index ) 
          {
              var targmenu='#sweetvariantsdropdown'+$(this).data('menu');
              
              if (this==clickedmenu)
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                      $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                  else
                  {
                      hideallmainnmenus(); //hide any active main menus up the page

                      $(this).addClass('active');
                      $(targmenu).velocity("slideDown", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });

                      $(this).find('i').velocity({rotateZ: "180deg"}, { duration: 500 });
                     
                  }
              }
              else
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                      $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                 
              }

          });

          

      });





      $('#collectionmenu .menutoggle').click(function()
      {
          var clickedmenu=this;

          $( '#collectionmenu .menutoggle' ).each(function( index ) 
          {
              var targmenu='#collectiondropdown'+$(this).data('menu');
              
              if (this==clickedmenu)
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                      $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                  else
                  {
                      hideallmainnmenus(); //hide any active main menus up the page

                      
                      $(this).css('margin-top');
                      $(this).addClass('active');
                      $(targmenu).velocity("slideDown", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });

                      $(this).find('i').velocity({rotateZ: "180deg"}, { duration: 500 });
                      
                  }
              }
              else
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                      $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                 
              }

          });

          

      });



      function hideallcollectionmenus()
      {

          $( '#collectionmenu .menutoggle' ).each(function( index ) 
          {
              var targmenu='#collectiondropdown'+$(this).data('menu');

              if ($(this).hasClass('active'))
              {
                  $(this).removeClass('active');
                  $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                  $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
              }
          });

      }

      function hideallmainnmenus()
      {

          $( '#mainmenubar .menutoggle' ).each(function( index ) 
          {
              var targmenu='#menudropdown'+$(this).data('menu');

              if ($(this).hasClass('active'))
              {
                  $(this).removeClass('active');
                  $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                  $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
              }
          });

      }

      


      jQuery('#mainmenubar .menutoggle').click(function()
      {
          var clickedmenu=this;

          $( '#mainmenubar .menutoggle' ).each(function( index ) 
          {
              var targmenu='#menudropdown'+$(this).data('menu');

              $('body').removeClass('fixed');
              $('body').css('height','');
              $('body').css('overflow','');
              
              
              if (this==clickedmenu)
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                      //$(targmenu).velocity('stop');
                      $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                  else
                  {
                      hideallcollectionmenus(); //hide any active collection menus down the page

                      $(this).addClass('active');
                      $(targmenu).velocity('stop');
                      $(targmenu).velocity("slideDown", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });

                      $(this).find('i.oneeighty').velocity({rotateZ: "180deg"}, { duration: 500 });
                      $(this).find('i.threesixty').velocity({rotateZ: "360deg"}, { duration: 500 });

                      //$(this).find('i').addClass('active');

                      //load cart contents if cart clicked
                      if ($(this).data('menu')=='five')
                      {
                          $( "#menudropdownfive > div" ).load( "/cart #cartcontents", loadedcart);

                          

                          // need to do this only if header is not already at the top of the screen


                          var theheadertop = $('#theheader').offset().top; 
                          var theheadertopy=theheadertop - $(window).scrollTop();
                          var theheaderh= $('#theheader').height();

                          

                          if (theheadertopy > 0)
                          {
                              //console.log('the header is at:'+theheadertopy);
                              $('html,body').animate({ scrollTop: $(window).height()+1 }, 'slow');
                          }

                          var croppedcartheight = $(window).height() - $('#theheader').height();
                          $('.cartholder').css('max-height',croppedcartheight+'px');

                          //$('body').addClass('fixed');
                          $('body').css('height',$(window).height()+'px');
                          $('body').css('overflow','hidden');


                          //trigger resize to correct layout
                          $(window).resize();

                      }

                  }
              }
              else
              {
                  if ($(this).hasClass('active'))
                  {
                      $(this).removeClass('active');
                    $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
                      $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
                  }
                 
              }

          });

          

      });


      function loadedcart()
      {
          Currency.convertAll(defaultCurrency,Currency.currentCurrency); 
                            
          $('#cart-update').click(function(e)
          {
                e.preventDefault();
                Shopify.updateCartFromForm('cartform', function(cart)
                {
                      
                      var currentnumitems=parseInt($('.itemcount').html());
                      $('.itemcount').removeClass('numitems-'+currentnumitems);
                      $('.itemcount').html(cart.item_count);
                      $('.itemcount').addClass('numitems-'+cart.item_count);

                      $( "#menudropdownfive > div" ).load( "/cart #cartcontents", loadedcart);
                });
                              
                                
          });

          $('.cart-product-remove a').click(function(e)
          {
               e.preventDefault();
               var itemid=$(this).data('item');
               $('#updates_'+itemid).val(0);
               $('#cart-update').click();
                          
          });

          $('#cartholder #keep-shopping').click(function(e)
          {
              e.preventDefault();
              hideallmainnmenus();
              $('body').css('height','');
              $('body').css('overflow','');
              
          });

          //trigger resize to correct layout
          $(window).resize();


      }

});



function hideallvariantmenus()
{

    $( '#sweetvariantsmenu .menutoggle' ).each(function( index ) 
    {
        var targmenu='#sweetvariantsdropdown'+$(this).data('menu');

        if ($(this).hasClass('active'))
        {
            $(this).removeClass('active');
            $(targmenu).velocity("slideUp", { duration: 500, complete: function(elements) { $(elements).css('height', 'auto'); } });
            $(this).find('i').velocity({rotateZ: "0deg"}, { duration: 500 });
        }
    });

}



function loadSvg(target, url) 
{
  if (typeof SVGRect != "undefined") 
  {
    var ajax = new XMLHttpRequest();
    ajax.open("GET", url + ".svg", true);
    ajax.onload = function(e) 
    {
      $(target).html(ajax.responseText);

    }

    ajax.send();

  } 
  else 
  {
    // fallback
    $(target).html("<img src='" + url + ".png' />");
  }
}
